import { render } from "./NotificationPopup.vue?vue&type=template&id=00c8d627"
import script from "./NotificationPopup.vue?vue&type=script&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__